import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NavbarComponent } from './shared/navbar/navbar.component';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule, RouterLink, NavbarComponent],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {
  certifications = [
    { icon: '🌿', name: 'USDA Organic' },
    { icon: '🌱', name: 'BioAgriCert Organic' },
    { icon: '🏭', name: 'GMP Standards' },
    { icon: '📋', name: 'ISO Certified' },
    { icon: '✅', name: 'FSSAI Compliant' },
  ];

  qualitySteps = [
    { title: 'Responsible Sourcing', description: 'Ingredients sourced from trusted farms following natural agricultural practices.' },
    { title: 'Ingredient Selection', description: 'Raw materials carefully selected to maintain consistent quality and authenticity.' },
    { title: 'Controlled Processing', description: 'Processing preserves natural nutrients, purity, and effectiveness.' },
    { title: 'Certified Manufacturing', description: 'Facilities follow internationally recognized safety and quality protocols.' },
    { title: 'Secure Packaging', description: 'Products packed to maintain freshness, purity, and integrity.' },
  ];
}
